import { LitElement, html, css } from './lit-core.min.js';
import PhotoSwipeLightbox from './photoswipe-lightbox.esm.js';
import PhotoSwipe from './photoswipe.esm.js';

class BundleImages extends LitElement {
	static properties = {
		screenshot: { type: String },
		images: { type: Array },
		captions: { type: Array }
	}

	constructor() {
		super();
		this.screenshot = null;
		this.images = [];
		this.captions = [];
		this.lightbox = undefined;

		// Reset carousel scroll when element becomes visible
		const observer = new IntersectionObserver((entries, observer) => {
			if (entries.some(entry => entry.isIntersecting)) {
				let carousel = this.querySelector('card-carousel');
				carousel.resetScroll();
				observer.disconnect();
			}
		});

		observer.observe(this);
	}

	initLightbox() {
		if (this.lightbox) this.lightbox.destroy();

		this.lightbox = new PhotoSwipeLightbox({
			gallery: '#bundleImageCarousel',
			children: 'a:not(.card-carousel__infinite-item)',
			pswpModule: PhotoSwipe,
			bgClickAction: 'close'
		});

		this.lightbox.init();
		this.lightbox.on('openingAnimationStart', () => this.classList.add('lightbox-open'));
    this.lightbox.on('closingAnimationEnd', () => this.classList.remove('lightbox-open'));
		this.lightbox.on('firstUpdate', () => {
			const pswp = this.lightbox.pswp;
			pswp.container.addEventListener('click', e => {
				if (e.target.classList.contains('pswp__item')) {
					pswp.close();
				}
			});
		});


		this.lightbox.on('uiRegister', () => {
			this.lightbox.pswp.ui.registerElement({
				name: 'custom-caption',
				order: 9,
				isButton: false,
				appendTo: 'root',
				html: 'Caption text',
				onInit: (el, pswp) => {
					pswp.on('change', () => {
						const currSlideElement = pswp.currSlide.data.element;
						let captionHTML = '';
						if (currSlideElement) {
							captionHTML = currSlideElement.dataset.caption;
						}
						el.innerHTML = captionHTML || '';
					});
				}
			});
		});
	}

	createRenderRoot() {
		return this;
	}

	render() {
		return html`
			<card-carousel 
				@cardchange="${e => window.trackEvent('BYOB', 'Img-swipe')}"
				style="--cards: 1;" 
				data-infinite="true" 
				id="bundleImageCarousel"
			>
				<card-carousel-items>
					${this.screenshot ? html`
					<a 
						@click="${e => window.trackEvent('BYOB', 'Img-click')}"
						class="bundle__image bundle__image--screenshot" data-pswp-src="${this.screenshot}" target="_blank" data-pswp-width="1200" data-pswp-height="1500" data-caption="">
						<img width="400" height="500" src="${this.screenshot}" />
					</a>
					` : html`
					<div class="bundle__image--placeholder">
					</div>
					`}
					${this.images.filter(image => image).map((image, idx) => html`
					<a 
						@click="${e => window.trackEvent('BYOB', 'Img-click')}"
						class="bundle__image" href="${image}" target="_blank" data-pswp-width="1200" data-pswp-height="1500" data-caption="${this.captions[idx]}">
						<img width="400" height="500" src="${image}&width=600" />
					</a>
					`)}
				</card-carousel-items>
			</card-carousel>
		`
	}

	updated() {
		super.updated();
		let carousel = this.querySelector('card-carousel');
		carousel.update();
		carousel.resetScroll();
		this.initLightbox();
	}
}

customElements.define('bundle-images', BundleImages);